import ROUTE_NAMES from '@/app/admin/router/router-const'
export default [
  {
    path: 'course_management',
    name: ROUTE_NAMES.COURSE_MANAGMENT,
    component: () => import('../CMPage.vue'),
  },
  {
    path: 'course_management_all',
    name: ROUTE_NAMES.COURSE_MANAGMENT_ALL,
    component: () => import('../CMAllPage.vue')
  },
  {
    path: 'cursussen',
    name: ROUTE_NAMES.CURSSUSEN,
    component: () => import('../CMCurssusenPage.vue')
  },
]